import codetool from "@/scripts/codetool"
import service from "@/scripts/service"
import secure from "@/scripts/secure"

let json_example =`{
  "name":"yespu",
  "description":"代码工具集合"
}`

let xml_example =`<web>
	<name>yespu</name>
	<description>代码工具集合</description>
</web>`
/**
 * 全局对象方法
 */

export default {
  codetool,
  secure,
  service,
  jsonexample:json_example,
  xmlexample:xml_example,
  webcode: "鲁ICP备2021024267号-6",
}
